import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { AnalistasService } from './services/analistas.service';
import { IAnalistaListRequest, IAnalistaListItem } from './interfaces/analistas.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-analistas',
  templateUrl: './analistas.component.html',
  providers: [MessageService]
})
export class AnalistasComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedAnalista: IAnalistaListItem | null = null;
  dataSource: IAnalistaListItem[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'susuario', header: 'Analista', sortable: true },
    { field: 'nombre_analista', header: 'Nombre', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private analistasService: AnalistasService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    const payload: IAnalistaListRequest = {
      limit: '999'
    };
    this.analistasService.getAnalistasList(payload).subscribe({
      next: (response) => {
        this.dataSource = response.data;
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        console.error('Error al cargar analistas:', error);
      }
    });
  }

  openCreate(): void {
    this.selectedAnalista = null;
    this.displayDialog = true;
  }

  openUpdate(row: IAnalistaListItem): void {
    this.selectedAnalista = { ...row };
    this.displayDialog = true;
  }

  openDelete(row: IAnalistaListItem): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este analista?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.analistasService.deleteAnalista(row.susuario).subscribe({
          next: (response) => {
            if (response.success) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Analista eliminado correctamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar el analista'
              });
            }
          },
          error: (error) => {
            console.error('Error:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar el analista'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.selectedAnalista = null;
    this.displayDialog = false;
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  onSave(event: { success: boolean; message: string }): void {
    if (event.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: event.message
      });
      this.displayDialog = false;
      this.loadData();
    }
  }
} 